export var getMenuProductsToList = function (_a) {
    var menu = _a.menu;
    return menu.reduce(function (acc, _a) {
        var staticURL = _a.staticURL, name = _a.name, url = _a.url, nextLevelItems = _a.nextLevelItems, path = _a.path, config = _a.config, extendedRouteName = _a.extendedRouteName;
        if (staticURL) {
            acc.push({
                staticURL: staticURL,
                name: name,
                url: url,
                path: path,
                config: config,
                extendedRouteName: extendedRouteName,
            });
        }
        if (nextLevelItems) {
            var flattenedNextLevelItems = getMenuProductsToList({
                menu: nextLevelItems,
            });
            acc.push.apply(acc, flattenedNextLevelItems);
        }
        return acc;
    }, []);
};
